import React from 'react'
import { useSelector } from 'react-redux'
import { IconGauge } from '@tabler/icons-react'
import { isEmpty } from 'lodash'

import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { Progress } from '@/components/progress/Progress'
import { formatPolicyWindow, policyUsagePercent } from '../kodi.constants'

/**
 * Header hoverable showing the user's enforced usage policies (from the ws
 * usage_update event), each as a 0–100% bar of tokens spent over the policy's
 * rolling window. Org-wide and user policies both cap this user's own usage, so
 * the scope isn't distinguished. Hidden entirely when no policy applies.
 */
export const KodiUsageStatus = () => {
  const { usagePolicies } = useSelector((state) => state.kodi)

  if (isEmpty(usagePolicies)) {
    return null
  }

  const content = (
    <div className="kodi-usage">
      {usagePolicies.map((policy) => (
        <div key={policy.id} className="kodi-usage__policy">
          <div className="kodi-usage__policy-labels">
            <span>{formatPolicyWindow(policy.window_hours)}</span>
            <span>{Math.round(policyUsagePercent(policy))}%</span>
          </div>
          <Progress value={policyUsagePercent(policy)} />
        </div>
      ))}
    </div>
  )

  return (
    <InteractiveTooltip content={content} placement="bottom" theme="light">
      <span
        className="kodi-status kodi-status--usage"
        aria-label="Usage policies"
        data-testid="kodi-usage-status"
        // Focusable so keyboard users can open the tooltip (it opens on focus
        // and click, hence the interactive role).
        role="button"
        tabIndex={0}
      >
        <IconGauge size={14} className="kodi-status__icon" aria-hidden="true" />
        <span className="kodi-status__label">Usage</span>
      </span>
    </InteractiveTooltip>
  )
}
